import axios from '../utils/axios';

// 获取所有分类配置
export const getAllCategories = () => {
  return axios.get('/api/category/list');
};

// 创建分类配置
export const createCategory = (data) => {
  return axios.post('/api/category/create', data);
};

// 更新分类配置
export const updateCategory = (id, data) => {
  return axios.put(`/api/category/update?id=${id}`, data);
};

// 删除分类配置
export const deleteCategory = (id) => {
  return axios.delete(`/api/category/delete?id=${id}`);
};
